import React, { useState, useEffect, useMemo } from 'react';
import { useToggle } from 'react-use';
import PropTypes from 'prop-types';
import { numeralFormat } from '../../../common/numeralFormat';

import styles from './card-grid.module.css';
import Checkbox from '../../checkbox';
import CSVLink from "../../../useHook/useCSV";

function CardGrid(props) {
    const { data, title, description, downloadCSV } = props;

    const [on, toggle] = useToggle(true);
    const [list, setList] = useState({
        left: [],
        right: [],
    });

    useEffect(() => {
        const left = data.left || [];
        const right = data.right || [];
        if (data.left) {
            toggle(true);
        }
        if (data.right) {
            toggle(false);
        }
        for (let i = 0; i < 9; i++) {
            const currentDataLeft = (left[i] && left[i] !== '-') ? left[i] : undefined;
            const currentDataRight = (right[i] && right[i] !== '-') ? right[i] : undefined;

            left[i] = currentDataLeft ? {
                ...left[i],
                middle: numeralFormat(left[i].middle, 3),
                opacity: parseInt(left[i].color) / 100
            } : {
                color: '20%',
                opacity: 0.2,
                lower: '',
                middle: '-',
                upper: '',
            };

            right[i] = currentDataRight ? {
                ...right[i],
                middle: numeralFormat(right[i].middle, 3),
                opacity: parseInt(right[i].color) / 100
            } : {
                color: '20%',
                opacity: 0.2,
                lower: '',
                middle: '-',
                upper: '',
            };
        }

        setList({ left, right });
    }, [data]);

    const memoList = useMemo(() => {
        return on ? list.left : list.right;
    }, [list, on]);

    const disabledLeft = useMemo(() => {
        return data.left === null;
    }, [list]);

    const disabledRight = useMemo(() => {
        return data.right === null;
    }, [list]);

    const dataCSV = useMemo(() => {
        const memo = data.memo || '';
        const values = [];
        const labels = ['左上', '中央上', '右上', '左中央', '中央', '右中央', '左下', '中央下', '右下'];
        const items = (data.left ? data.left : data.right) || [];
        const checkboxTitle = on ? '左打者' : '右打者';
        items.forEach((item, index) => {
            const upper = item.upper ? item.upper.split('-') : ['', ''];
            const lower = item.lower ? item.lower.replace('HR', '').replace('K', '').split('|') : ['', ''];
            values.push([
                labels[index],
                upper[0].trim(),
                upper[1].trim(),
                item.middle,
                lower[0].trim(),
                lower[1].trim(),
            ])
        });
        return [
            [title],
            ['', '打数', '安打', '打率', '本塁打', '三振'],
            ...values,
            [checkboxTitle],
            [description],
        ];
    }, [data, on, title, description]);

    return <>
        <div className={styles.cardContent}>
            <div className={styles.leftContent}>
                <img style={{ paddingBottom: 15 }} src={on ? '/img/baseball-man-left-bold.svg' : '/img/baseball-man-light.svg'} alt="" />
            </div>
            <div className={styles.centerContent}>
                {memoList.map((item, idx) => {
                    return <div key={idx} className={styles.centerItem} style={{ opacity: item.opacity }}>
                        <div>{item.upper}</div>
                        <div>{item.middle}</div>
                        <div>{item.lower}</div>
                    </div>
                })}
            </div>
            <div className={styles.rightContent}>
                <img style={{ paddingBottom: 15 }} src={!on ? '/img/baseball-man-bold.svg' : '/img/pic_batter_right_inactive.svg'} alt="" />
            </div>
        </div>
        <div className={styles.footerCard}>
            <div style={{ textAlign: 'right' }}>
                <label>
                    <Checkbox disabled={disabledLeft} checked={on} onChange={() => toggle(true)} />
                    <span style={{ paddingLeft: 5 }}>
                        左打者
                    </span>
                </label>
            </div>
            <div style={{ flex: 1, textAlign: 'center', maxWidth: 300 }}>
                <img src="/img/pic_homebase.svg" alt="" />
            </div>
            <div>
                <label>
                    <Checkbox disabled={disabledRight} checked={!on} onChange={() => toggle(false)} />
                    <span style={{ paddingLeft: 5 }}>右打者</span>
                </label>
            </div>
        </div>
        <CSVLink data={dataCSV} autoDownload={downloadCSV} filename={'player-topic-card-grid.csv'} />
    </>
}

CardGrid.propTypes = {
    data: PropTypes.object
};

CardGrid.defaultProps = {
    data: {
        left: [],
        right: [],
    }
};

export default CardGrid;
